/* eslint-disable */
import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { autobind } from 'core-decorators';
import get from 'lodash/get';
import CSSModules from 'react-css-modules';
import trim from 'lodash/trim';
import size from 'lodash/size';
import isEqual from 'lodash/isEqual';
import differenceBy from 'lodash/differenceBy';
import cn from 'classnames';

import Button from '../../Button';
import Icon from '../../Icon';
import UrlInput from './UrlInput';
import UrlPreview from './UrlPreview';
import Popup from '../../common/Popup';
import SimpleImagePreview from '../../common/SimpleImagePreview';
import FilePicker from '../../Chat/components/FilePicker';
import TextInput from '../../TextInput';
import DiscardModal from '../../common/DiscardModal';
import ErrorBlock from '../../common/ErrorBlock';
import Loader from '../../common/Loader';
import ContentArea from '../../ContentArea';
import Content from '../../ContentArea/Content';
import Controls from '../../ContentArea/Controls';
import ControlsItem from '../../ContentArea/ControlsItem';

import { preloaderImage } from '../../../utils/preloaderImage';
import sanitizeHtml from '../../../utils/sanitizeHtml';
import prettifyText from '../../../utils/prettifyText';
import { actions as newPostFormActions } from '../../../redux/communities/newPostForm';
import { actions as urlPreviewActions } from '../../../redux/common/urlPreview';
import { COLORS } from '../../../constants/styles';
import { COMMON, COMMUNUNNITY_NEW_POST } from '../../../constants/strings';
import convertXMLtoString from '../../../utils/convertXMLtoString';
import { NEW_MESSAGE_ERRORS } from '../../../constants/chat';
import { isDesktop } from '../../../utils/mobileHelpers';
import {
  IMAGE_ALLOWED_FORMATS,
  COMMUNITIES_ACCESS_LEVELS,
} from '../../../constants';

import styles from './index.styl';

const POST_LIMIT_SIZE = 4000;
const POST_IMAGE_LIMIT_MB = 10;
const MAX_POST_IMAGES_NUMBER = 10;

const { READ_AND_POST_WITH_APPROVAL } = COMMUNITIES_ACCESS_LEVELS;
const {
  allowedFormatError,
  fileError,
  maxAttachmentNumber,
  sendForApproval,
  addPost,
  editPost,
  caption,
  attachURL,
  addPhoto,
  urlError,
} = COMMUNUNNITY_NEW_POST;

const mapStateToProps = state => ({
  form: state.communities.newPostForm,
  urlPreviewRequest: state.common.urlPreview,
});

const mapDispatchToProps = {
  clearForm: newPostFormActions.clearForm,
  updateForm: newPostFormActions.updateForm,
  urlPreview: urlPreviewActions.send,
  clearUrlPreview: urlPreviewActions.clear,
};

@connect(
  mapStateToProps,
  mapDispatchToProps,
)
@injectIntl
@CSSModules(styles, { allowMultiple: true })
export default class PostForm extends PureComponent {
  static propTypes = {
    intl: PropTypes.shape({
      formatMessage: PropTypes.func,
    }),
    onCancel: PropTypes.func,
    onSubmit: PropTypes.func,
    urlPreview: PropTypes.func,
    clearUrlPreview: PropTypes.func,
    form: PropTypes.shape({
      content: PropTypes.string,
    }),
    clearForm: PropTypes.func,
    updateForm: PropTypes.func,
    error: PropTypes.string,
    submitting: PropTypes.bool,
    urlPreviewRequest: PropTypes.shape({
      description: PropTypes.string,
      url: PropTypes.string,
      preview: PropTypes.string,
      video: PropTypes.string,
      title: PropTypes.string,
      sending: PropTypes.bool,
      succeed: PropTypes.bool,
    }),
    edit: PropTypes.bool,
    attachment: PropTypes.shape({
      id: PropTypes.number,
    }),
    isModalOpen: PropTypes.bool,
    modalTitle: PropTypes.string,
    discardModalTitle: PropTypes.string,
    discardBtnText: PropTypes.string,
    accessLevel: PropTypes.string,
    isNotificationOpen: PropTypes.bool,
    openNotification: PropTypes.func,
    closeNotification: PropTypes.func,
    isModerator: PropTypes.bool,
  };

  static childContextTypes = {
    intl: PropTypes.object,
  };

  state = {
    attachUrl: false,
    attachImage: false,
    previewImage: null,
    attachKind: null,
    content: '',
    fileError: false,
    attachUrlLink: '',
    files: [],
    attachedFiles: [],
    loading: false,
    isDiscardModalOpened: false,
    editedPostData: null,
  };

  getChildContext() {
    return {
      intl: this.props.intl,
    };
  }

  componentDidMount() {
    const { edit } = this.props;
    const existingAttachments = get(this.props.form, 'attachment.files', []);
    const attachedContent = get(this.props.form, 'content');
    const content = attachedContent && prettifyText(attachedContent);
    const urlPreview = this.props.urlPreviewRequest.succeed
      ? this.props.urlPreviewRequest
      : get(this.props.form, 'attachment.urlPreview');

    if (content || !!size(existingAttachments) || urlPreview) {
      const postFiles = existingAttachments.map(item => ({
        ...item,
        type: 'ATTACHMENT',
      }));
      const data = {
        content: content && convertXMLtoString(content),
        attachImage: !!size(existingAttachments),
        files: [...postFiles],
        urlPreview: urlPreview || null,
        attachedFiles: [...postFiles],
        attachUrl: !!urlPreview,
        editedPostData: edit && {
          content: content && convertXMLtoString(content),
          urlPreview: urlPreview || null,
          files: [...postFiles],
        },
      };
      this.setState({
        ...data,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      !this.props.urlPreviewRequest.succeed &&
      nextProps.urlPreviewRequest.succeed
    ) {
      this.setState({
        urlPreview: nextProps.urlPreviewRequest,
      });
    }
  }

  @autobind
  attachUrl() {
    this.setState({
      attachUrl: true,
      attachKind: 'link',
    });
  }

  arrayToFormData(arr, formData) {
    arr.forEach(object => {
      formData.append('attachment_attributes[files][]', object);
    });
  }

  filterByType(type) {
    const { files } = this.state;
    return files.filter(file => file.type === type);
  }

  @autobind
  submitPost() {
    const { attachment } = this.props;
    const {
      content: rawContent,
      urlPreview,
      attachedFiles,
      attachImage,
    } = this.state;
    const content = sanitizeHtml(rawContent.trim(), true, []);
    const post = new FormData();

    const uploadedFiles = this.filterByType('UPLOAD_TYPE').map(
      file => file.attachImage,
    );
    const existedFiles = this.filterByType('ATTACHMENT');

    if (urlPreview) {
      post.append(
        'attachment_attributes[url_preview][title]',
        urlPreview.title,
      );
      post.append(
        'attachment_attributes[url_preview][description]',
        urlPreview.description,
      );
      post.append(
        'attachment_attributes[url_preview][preview]',
        urlPreview.preview,
      );
      post.append('attachment_attributes[url_preview][url]', urlPreview.url);

      urlPreview.video =
        urlPreview.video && urlPreview.video.includes('?autoplay=1')
          ? urlPreview.video.slice(0, urlPreview.video.indexOf('?autoplay=1'))
          : urlPreview.video;

      urlPreview.video && post.append(
        'attachment_attributes[url_preview][video]',
        urlPreview.video,
      );
    }

    if (size(uploadedFiles)) {
      this.arrayToFormData(uploadedFiles, post);
    }

    if (content) {
      post.append('content', content);
    }

    if (attachment && attachment.id) {
      post.append('attachment_attributes[id]', attachment.id);
      if (!urlPreview && !attachImage) {
        post.append('attachment_attributes[_destroy]', true);
      }
      differenceBy(attachedFiles, existedFiles, 'index').forEach(object => {
        post.append(
          'attachment_attributes[removed_files_indexes][]',
          object.index,
        );
      });
    }

    this.props.onSubmit(post);
    this.props.updateForm({
      content,
    });
  }

  @autobind
  cancel() {
    this.props.onCancel();
    this.props.clearForm();
    this.props.clearUrlPreview();
  }

  @autobind
  handleErrors(errorKeys) {
    const {
      intl: { formatMessage },
    } = this.props;
    const errorReasons = get(errorKeys, 'errors');
    const errorText = [];
    if (
      errorReasons.includes(NEW_MESSAGE_ERRORS.ATTACHMENT_NOT_ALLOWED_FORMAT)
    ) {
      errorText.push(formatMessage(allowedFormatError));
    }
    if (errorReasons.includes(NEW_MESSAGE_ERRORS.ATTACHMENT_MAX_SIZE)) {
      errorText.push(
        formatMessage(fileError, {
          size: POST_IMAGE_LIMIT_MB,
        }),
      );
    }
    if (errorReasons.includes(NEW_MESSAGE_ERRORS.ATTACHMENT_MAX_NUMBER)) {
      errorText.push(formatMessage(maxAttachmentNumber));
    }
    this.setState({
      fileError: true,
      filesErrorText: errorText,
    });
  }

  @autobind
  cancelPreview() {
    this.setState({ attachUrl: false, urlPreview: null });
    this.props.clearUrlPreview();
  }

  @autobind
  async handleAttachmentPick(file) {
    const url = await preloaderImage(file);

    const postFile = {
      previewImage: url,
      attachImage: file,
      fileError: false,
      type: 'UPLOAD_TYPE',
    };
    return postFile;
  }

  submitPostWithApproval = () => {
    this.props.openNotification();
    this.props.onCancel();
    this.submitPost();
    this.props.clearForm();
    this.props.clearUrlPreview();
  };

  handleAttachments = files => {
    this.setState({
      loading: true,
      fileError: false,
    });
    Promise.all(files.map(file => this.handleAttachmentPick(file)))
      .then(result => {
        this.setState(prevState => ({
          files: [...prevState.files, ...result],
          loading: false,
          attachImage: true,
        }));
      })
      .catch(err => {
        this.setState({ loading: false });
      });
  };

  removeAttachedFile = file => {
    const { files } = this.state;
    const filteredFiles = files.filter(item => item !== file);
    this.setState({
      files: filteredFiles,
      attachImage: !!size(filteredFiles),
    });
  };

  getEmptyInputStatus = content => {
    return !trim(content).length;
  };

  getPostLengthError = content => {
    return get(content, 'length') > POST_LIMIT_SIZE;
  };

  getEmptyPostStatus = (content, urlPreview, attachImage) => {
    return (
      typeof content === 'string' &&
      this.getEmptyInputStatus(content) &&
      !urlPreview &&
      !attachImage
    );
  };

  handleToggleDiscardModal = () => {
    const { isDiscardModalOpened } = this.state;
    this.setState({ isDiscardModalOpened: !isDiscardModalOpened });
  };

  handleCloseForm = () => {
    const {
      editedPostData,
      content,
      files,
      urlPreview,
      attachImage,
    } = this.state;
    const { edit } = this.props;
    const isEmptyPost = this.getEmptyPostStatus(
      content,
      urlPreview,
      attachImage,
    );
    if (edit) {
      const currentData = {
        content,
        urlPreview,
        files,
      };
      if (isEqual(editedPostData, currentData)) {
        return this.cancel();
      }
      return this.handleToggleDiscardModal();
    }
    return isEmptyPost ? this.cancel() : this.handleToggleDiscardModal();
  };

  render() {
    const {
      intl: { formatMessage },
      error,
      submitting,
      edit,
      urlPreviewRequest,
      isModalOpen,
      modalTitle,
      discardModalTitle,
      discardBtnText,
      accessLevel,
      isNotificationOpen,
      closeNotification,
      isModerator,
    } = this.props;
    const {
      attachUrl,
      attachImage,
      content: value,
      fileError,
      urlPreview,
      files,
      loading,
      filesErrorText,
      isDiscardModalOpened,
    } = this.state;
    const isEmptyInput = this.getEmptyInputStatus(value);
    const isPostLengthError = this.getPostLengthError(value);
    const isEmptyPost = this.getEmptyPostStatus(value, urlPreview, attachImage);
    const isFilesLengthError = size(files) > MAX_POST_IMAGES_NUMBER;
    const disabled = isEmptyPost || isFilesLengthError || isPostLengthError;
    const isErrored = error || fileError || isFilesLengthError;
    const errorMessage = fileError
      ? filesErrorText.map(err => <span>{err}</span>)
      : formatMessage(maxAttachmentNumber);
    const needsApproval =
      !isModerator && accessLevel === READ_AND_POST_WITH_APPROVAL;
    const sendPost = needsApproval ? sendForApproval : addPost;
    const submitBtnText = edit ? editPost : sendPost;

    return (
      <Fragment>
        <Popup
          title={modalTitle}
          strictClose
          width={isDesktop() ? 'postCommunity' : 'medium'}
          mobileFullScreen
          onClose={this.handleCloseForm}
          opened={isModalOpen}
        >
          <ContentArea>
            <If condition={submitting}>
              <Loader />
              <Else />
              <Content
                fullHeight
                empty={false}
                style={{ maxHeight: 'calc(100% - 50px)', flexGrow: 'unset' }}
              >
                <div styleName="post-form">
                  <div styleName="input-wrapper" className="mt1 pb1 pl1 pr2">
                    <TextInput
                      autoresize
                      autoFocus
                      textarea
                      className="ma1"
                      rows="4"
                      color="primary"
                      label={formatMessage(caption)}
                      inputHeight={22}
                      style={{
                        lineHeight: '21px',
                        maxHeight: '210px',
                        backgroundColor: 'white',
                        borderRadius: '2px 2px 0 0',
                        border: 'none',
                      }}
                      wrapperStyle={{ margin: 0 }}
                      value={value}
                      onChange={content => this.setState({ content })}
                      useNumberHeight
                    />
                    <div styleName="post-attachments">
                      <If
                        condition={
                          !attachUrl && !urlPreview && !attachImage && !loading
                        }
                      >
                        <div
                          styleName="attach-item"
                          className="pa2"
                          onClick={this.attachUrl}
                        >
                          <Icon
                            name="link"
                            className="mr2"
                            style={{ fill: COLORS.bluePrimary }}
                          />
                          <FormattedMessage {...attachURL} />
                        </div>
                      </If>
                      <div
                        styleName={cn('info', {
                          'info--errored': isPostLengthError,
                        })}
                      >
                        <span
                          styleName={isEmptyInput ? 'info--disabled' : null}
                        >
                          {`${size(value)}`}/
                        </span>
                        <span
                          styleName={
                            !isPostLengthError ? 'info--disabled' : null
                          }
                        >
                          {POST_LIMIT_SIZE}
                        </span>
                      </div>
                    </div>
                    <div className="mt3 flex flex-wrap">
                      <If condition={size(files)}>
                        {files.map((file, i) => (
                          <SimpleImagePreview
                            key={(file.previewImage || file.url) + i}
                            src={file.previewImage || file.url}
                            onCancel={() => this.removeAttachedFile(file)}
                            small
                            showCloseBtn
                          />
                        ))}
                      </If>
                      <If condition={loading}>
                        <Loader />
                      </If>
                      <If
                        condition={
                          !loading &&
                          size(files) < MAX_POST_IMAGES_NUMBER &&
                          !attachUrl
                        }
                      >
                        <div styleName="attach-image">
                          <FilePicker
                            maxSize={POST_IMAGE_LIMIT_MB}
                            allowedFormats={IMAGE_ALLOWED_FORMATS}
                            inputFileLabel="post-image-attachment"
                            onError={this.handleErrors}
                            onFilePick={this.handleAttachments}
                            multiple
                          >
                            <div className="flex flex-column items-center">
                              <Icon
                                name="icon-plus"
                                className="mr2 mb2"
                                style={{ fill: COLORS.blueGray }}
                                size={24}
                              />
                              <FormattedMessage {...addPhoto} />
                            </div>
                          </FilePicker>
                        </div>
                      </If>
                    </div>
                    <If condition={attachUrl || urlPreview}>
                      <If condition={attachUrl && !urlPreview}>
                        <UrlInput
                          onCancel={this.cancelPreview}
                          onUrl={url => this.props.urlPreview({ url })}
                          formatMessage={formatMessage}
                        />
                        <If condition={urlPreviewRequest.sending}>
                          <Loader />
                        </If>
                        <If condition={urlPreviewRequest.rejected}>
                          <ErrorBlock
                            className="mt3"
                            errors={formatMessage(urlError)}
                          />
                        </If>
                      </If>
                      <If condition={urlPreview}>
                        <UrlPreview
                          className="mt2"
                          {...urlPreview}
                          onCancel={this.cancelPreview}
                        />
                      </If>
                    </If>
                    <If condition={needsApproval}>
                      <div styleName="approvalText">
                        {formatMessage({
                          id: 'community.newPost.needsApproval',
                        })}
                      </div>
                    </If>
                  </div>
                  <If condition={isErrored}>
                    <ErrorBlock
                      className="mt3"
                      errors={error || errorMessage}
                    />
                  </If>
                </div>
              </Content>
              <Controls>
                <ControlsItem>
                  <div className="mt3">
                    <Button
                      color="primary"
                      raised
                      type="button"
                      className="mr3"
                      onClick={
                        needsApproval
                          ? this.submitPostWithApproval
                          : this.submitPost
                      }
                      disabled={disabled}
                    >
                      <FormattedMessage {...submitBtnText} />
                    </Button>
                    <Button
                      color="accent"
                      raised
                      type="button"
                      onClick={this.handleCloseForm}
                    >
                      <FormattedMessage {...COMMON.cancel} />
                    </Button>
                  </div>
                </ControlsItem>
              </Controls>
            </If>
          </ContentArea>
        </Popup>
        <DiscardModal
          title={discardModalTitle}
          isOpened={isDiscardModalOpened}
          onSubmit={this.cancel}
          submitText={discardBtnText}
          cancelText={formatMessage({ id: 'common.goBack' })}
          onCancel={this.handleToggleDiscardModal}
        />
        <Popup
          opened={isNotificationOpen}
          withHeading={false}
          width="rubber"
          mobileFullScreen={false}
        >
          <div styleName="notification">
            <p>{formatMessage({ id: 'community.newPost.notification' })}</p>
            <Button color="primary" type="button" onClick={closeNotification}>
              {formatMessage({ id: 'common.ok' })}
            </Button>
          </div>
        </Popup>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Community/NewPost/PostForm.jsx